import { render, staticRenderFns } from "./CouponInfo.vue?vue&type=template&id=69220f95&scoped=true&"
import script from "./CouponInfo.vue?vue&type=script&lang=js&"
export * from "./CouponInfo.vue?vue&type=script&lang=js&"
import style0 from "./CouponInfo.vue?vue&type=style&index=0&id=69220f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69220f95",
  null
  
)

export default component.exports